<template>
  <div id="app">
    <div class="p-8 flex justify-center md:justify-start md:mx-28" id="nav">
      <a
        class="text-sm font-medium text-gray-400 px-4 hover:text-gray-600 uppercase cursor-pointer" 
        href="#home"
        >Home</a
      >
      <a
        class="text-sm font-medium text-gray-400 px-4 hover:text-gray-600 uppercase cursor-pointer"
        href="#features"
        >Features</a
      >
      <a
        class="text-sm font-medium text-gray-400 px-4 hover:text-gray-600 uppercase cursor-pointer"
        href="#access"
        >Get Access</a
      >
    </div>
    <!-- <router-view /> -->

    <HomeView id="home" />
    <Intro id="features" title="Explore the city" highlight="your way" imgSource="cover.png" subtitle="Interested in old town history and epic sea battles, but still like to get smudgy with local tomatoe pasta? No problem, you choose your interests and locations, on spot.  "/>
    <Intro title="Guided, but" highlight="on your pace" imgSource="cover2.png" subtitle="It's starting to get really hot and you prefer to get a drink in the meantime? No worries, you can continue the tour whenever you like"/>
    <Intro title="Find all the" highlight="hidden gems" imgSource="checkpoints.png" subtitle="Go beyond already ubiquitous locations and find that one tavern that only locals know about."/>
    <Intro title="Digestible and" highlight="fun trivia bites" imgSource="tour.png" subtitle="Evala displays short, fun and interesting information and stories about places you visit during a tour "/>
    <Intro title="Become a" highlight="content creator" imgSource="champ.png" subtitle="With our integrated feedback system, every adventurer can contribute with their suggestions and make the future experience even better"/>
    <Newsletter id="access" />
  
    <Footer />

  </div>
</template>

<script>
import HomeView from '@/views/Home.vue';
import Intro from '@/views/Intro.vue';
import Footer from '@/views/Footer.vue';
import Newsletter from '@/views/Newsletter.vue';

export default {
  components: {
    HomeView,
    Intro,
    Newsletter,
    Footer
  }
}
</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;500;800&display=swap');

#app {
  padding: 0;
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #131313;
  // background: #232329;
  background: #ffffff;
}

</style>
